import _ from 'lodash';
import { useEffect } from 'react';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
};

const usePlaces = () => {
  const { state: { places = initialState }, dispatch } = useGlobalContext(),
    { actions: headerActions } = useHeader();

  const { data, mutate } = useFetch({
    url: 'places/list',
    params: { term: places.term, offset: places.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Locais',
      count: _.get(data, 'count', 0),
      loading: _.get(places, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, places]);

  const list = (offset = 0, term) => {
    dispatch({ type: 'places', payload: { offset, term } });
  };

  const pageChange = (offset = 0) => {
    dispatch({ type: 'places', payload: { offset } });
  };

  const load = async (data = {}) => {
    try {
      dispatch({
        type: 'places',
        payload: { model: {}, formLoading: true },
      });
      let model = { active: true };

      if (data.id) {
        const response = await api.get('places/load', { params: { id: data.id } });
        model = response.data;
      }
      dispatch({ type: 'places', payload: { model, formLoading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const createOrUpdate = async (model, actions) => {
    try {
      dispatch({ type: 'places', payload: { formLoading: true } });

      let editing = !!(model && model.id),
        method = editing ? 'put' : 'post',
        path = editing ? 'update' : 'create';

      await api[method](`places/${path}`, model);

      mutate(data);

      showMessage('success', `Local ${editing ? 'atualizado' : 'criado'} com sucesso`);

      actions.toogleForm && actions.toogleForm();
    } catch (error) {
      failure(error, dispatch);
    }
  };

  return {
    state: {
      ...places,
      data: data || {},
      loading: !data,
    },
    actions: {
      pageChange,
      load,
      list,
      createOrUpdate,
    },
  };
};

const failure = (error, dispatch) => {
  dispatch({ type: 'places', payload: { loading: false, formLoading: false }});
  showMessage('error', error);
};

export default usePlaces;
